import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import ModalSesionCaducada from "./modalSesion";

function obtenerExpiracionMsDesdeJwt(token) {
  try {
    const payload = token.split(".")[1];
    if (!payload) return 0;

    // base64url -> base64 + padding
    let base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) base64 += "=".repeat(4 - pad);

    const datos = JSON.parse(atob(base64));
    return (datos.exp || 0) * 1000; // exp (segundos) -> ms
  } catch {
    return 0;
  }
}

export default function CaducidadToken() {
  const { token, handleLogout } = useAuth();
  const [mostrarModal, setMostrarModal] = useState(false);
  const temporizadorRef = useRef(null);

  useEffect(() => {
    if (temporizadorRef.current) clearTimeout(temporizadorRef.current);

    if (!token) {
      setMostrarModal(false);
      return;
    }

    const expMs = obtenerExpiracionMsDesdeJwt(token);
    const msRestantes = expMs - Date.now();

    if (!expMs || msRestantes <= 0) {
      setMostrarModal(true);
      return;
    }

    temporizadorRef.current = setTimeout(() => setMostrarModal(true), msRestantes);

    return () => {
      if (temporizadorRef.current) clearTimeout(temporizadorRef.current);
    };
  }, [token]);

  const alAceptar = () => {
    setMostrarModal(false);
    handleLogout(); 
  };

  if (!mostrarModal) return null;
  return <ModalSesionCaducada alAceptar={alAceptar} />;
}